package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.ProfessionalAvailability
import br.com.heyagenda.domain.repository.AvailabilityRepository
import kotlinx.coroutines.flow.Flow

class GetAvailabilityUseCase(
    private val repository: AvailabilityRepository
) {
    operator fun invoke(): Flow<ProfessionalAvailability> {
        return repository.getAvailability()
    }
}
